<div class="card text-center border-0" style="width: 100%; margin-top: 100px">
  <i class="bi bi-clipboard card-img-top" style="font-size: 100px"></i>
  <div class="card-body">
    <p class="card-text">{{ mensaje }}</p>
  </div>
</div>
